import { createEntityListPage } from "./createEntityListPage";
import { usePayees, useAddPayee, useUpdatePayee } from "../../api/lists";

export const PayeesPage = createEntityListPage({
  title: "Payees",
  entityType: "payee",
  useList: usePayees,
  useAdd: useAddPayee,
  useUpdate: useUpdatePayee,
});
